import { createFileRoute } from '@tanstack/react-router';
import { EditReportingWebhookRouteView } from '@/pages/workspaces/integrations/reporting-webhooks/routing';
import { LastWorkspaceResolver } from './-components';

function EditReportingWebhookRoute() {
  const { webhookId } = Route.useParams();

  return (
    <LastWorkspaceResolver>
      <EditReportingWebhookRouteView webhookId={webhookId} />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/$webhookId',
)({
  component: EditReportingWebhookRoute,
});
